/**
 * Created by dycon 2018/3/14.
 */
import React from 'react';
import {Form, Icon, Input, Button, Checkbox, message, Modal, Select, Radio} from 'antd';
import {config, CookieUtils, openNotice} from 'Utils';
import {checkPhone} from '../../utils/regexp';
import {login, checkRole, getLoginPhoneCode, loginCode, getQrCodeLogin} from '../../service/home';
import './home.css';
import logoA from '../../assets/images/logoA.jpg';
import xiaZaiAppCs from '../../assets/images/ceShiXiaZaiApp.png'; //测试环境
import xiaZaiApp from '../../assets/images/xiaZaiApp.png';
import setLanguageText from "../../utils/languageSet";

const FormItem = Form.Item;
const Option = Select.Option;

class Login extends React.Component {
    state = {
        loginData: {
            'userName': '',
            'password': ''
        },
        phoneData: {
            phoneNumber: '',
            code: ''
        },
        showCountdown: false,
        countdown: 59,
        showAccount: true,
        showCode: false,
        QrCodeImg: '',
        loginDown: false,
        language: CookieUtils.get('language') || "zh",
        languageSet: {}
    };

    componentDidMount() {
        setLanguageText("login", this);
        var loginData = JSON.parse(CookieUtils.get('login_data_information') || '{}');
        if (loginData) {
            this.setState({
                loginData: {
                    'userName': loginData.userName,
                    'password': loginData.password
                }
            });
        }
        this.getNav();
    }

    componentWillUnmount() {
        this.setState(() => false);
    }

    getNav() {
        var explorer = window.navigator.userAgent;
        if (explorer.indexOf("MSIE") >= 0) {
        } else if (explorer.indexOf("Firefox") >= 0) {
            Modal.warning({
                title: this.state.languageSet.tip,
                content: (
                    <div style={{fontSize: 20}}>{this.state.languageSet.tip1}</div>)
            });
        } else if (explorer.indexOf("Opera") >= 0) {
        } else if (explorer.indexOf("Chrome") >= 0) {
        }
    }

    getCode = () => {
        var self = this;
        this.props.form.validateFields(['phoneNumber'], (err, values) => {
            if (!err) {
                this.setState({
                    showCountdown: true
                });
                getLoginPhoneCode({
                    mobile: values.phoneNumber
                }).then(result => {
                    if (result && result.code == 200) {
                        this.setState({
                            showCountdown: true
                        });
                        openNotice('success', '获取验证码成功', (result && result.message) ? result.message : '');
                        this.timer = setInterval(function () {
                            var cd = self.state.countdown;
                            if (cd < 1) {
                                clearInterval(self.timer);
                                self.setState({
                                    showCountdown: false,
                                    countdown: 59
                                });
                            } else {
                                self.setState({
                                    countdown: cd - 1
                                });
                            }
                        }, 1000);
                    } else {
                        this.setState({
                            showCountdown: false
                        });
                        openNotice('error', '获取验证码失败', (result && result.message) ? result.message : '');
                    }
                });
            }
        });
    };
    toggleLoginType = () => {
        this.setState({
            showAccount: !this.state.showAccount,
            showCode: false,
        });
    };
    randomString = (len, charSet) => {
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.charAt(randomPoz);
        }
        return randomString;
    }
    showCodeLogin = () => {
        this.uuid = this.randomString(15);
        this.setState({
            showCode: true,
            QrCodeImg: `${config.server}/api/v1/dms/login/qrCode?uuid=${this.uuid}`
        });
    };
    checkQrCodeLogin = () => {
        this.timer = setInterval(() => {
            getQrCodeLogin({
                uuid: this.uuid
            }).then(res => {
                if (res && res.status) {
                    clearInterval(this.timer);
                    this.successCallback(res, null);
                }
            });
        }, 2000)
    };

    chLanguage = (e) => {
        this.setState({language: e.target.value});
        CookieUtils.set('language', e.target.value);
        setLanguageText("login", this);
    }
    successCallback = (result, values) => {
        if (result && result.status == true) {
            let ownIs = {
                'ownEmp': result.user.ownEmp,
                'isSecond': result.user.isSecond
            };
            window.localStorage.setItem('ownIs', JSON.stringify(ownIs));
            window.localStorage.setItem('session_token', result.token || '');
            let button_limits_end = {
                channel: false,
                store: false,
                warehouse: false,
                inventory: false,
                notReaching: false,
                inventoryRecords: false,
                goDownEntry: false,
                channel_list_01: false,
                channel_list_02: false,
                channel_startPro_01: false,
                store_detail_01: false,
                store_detail_02: false,
                store_detail_03: false,
                store_detail_04: false,
                staff_list_01: false,
                remark_file_01: false,
                remark_remark_01: false,
                channel_detail_01: false,
                channel_detail_02: false,
                channel_detail_03: false,
                channel_detail_04: false,
                channel_detail_05: false,
                linkman_detail_01: false,
                linkman_detail_02: false,
                linkman_detail_03: false,
                order_detail_01: false,
                order_detail_02: false,
                warehouse_list_01: false,
                houseDetail_detail_01: false,
                houseDetail_detail_02: false,
                godownEntry_list_01: false,
                info_list_01: false,
                info_detail_01: false,
                channelFunc_list_01: false,
                channelFunc_detail_01: false,
                order_list_01: false,
                warehouse_list_02: false,
                godownEntry_list_02: false,
                info_list_02: false,
                channelFunc_list_02: false,
                inventory_list_01: false,
                info_comment_01: false,
                channelList: false,
                startPro: false,
                notice_list_01: false,
                notice_list_02: false,

                home: false,
                systemA: false,
                product: false,
                productEn: false,
                productEn_import: false,
                shoppingCar: false,
                favorites: false,
                order: false,
                customerManagement: false,
                returnOrder: false,
                systemXX: false,
                info: false,
                notice: false,
                channelFunc: false,
                channelFunc1: false,
                infoRead: false,
                system: false,
                homeSet: false,
                purchaseUnit: false,
                creditChange: false,
                invoiceManagement: false,
                inventoryQuery: false,
                systemXY: false,
                customer: false,
                thingsOrder: false,
                productCustomer: false,
                subStock: false,
                stockControl: false,
                reportForm: false,
                accountInformation: false,
                discountedReport: false,
                discountStatements: false,
                accountStatement: false,
                customerReceivableInquiry: false,
                customerReturnQuery: false,
                discountPoolInquiries: false,
                deffDeliveryOffer: false,
                customerTaxReturn: false,
                customerInvoice: false,
                customerInvoiceDetail: false,
                customerNoInvoice: false,
                purchaseChart: false,
                financeChart: false,
                // promotion: false,
                // card: false,
                warehouseInventoryQuery: false,
                saferStorageSet: false,
                dealer: false,
                warehouse: false,
                inventory: false,
                notReaching: false,
                inventoryRecords: false,
                goDownEntry: false,
                org: false,
                people: false,
                account: false,
                job: false,
                region: false,
                zone: false,
                category: false,
                productSpec: false,
                productBrand: false,
                dictionary: false,
                globalVar: false,
                entrust: false,
                billingCtrl: false,
                receiving: false,
                returnGoods: false,
                traceOrder: false,
                customOrder: false,
                preOrder: false,
                specialOrder: false,
                PurchaseOrder: false,
                escrowOrder: false,
                escrowOrderShip:false,
                escrowOrderPrint:false,
                escrowOrderReceipt:false,
                escrowOrderOnhand:false,
                escrowOrderTransaction:false,
                comment: false,
                financialMgm: false,
                salesQuery: false,
                receivedPayment: false,
                payment: false,
                verifying: false,
                otherInfo: false,
                verifyingDetail: false,
                secCusOrder: false,
                survey: false,
                invoiceManagement_list_01: false,
                invoiceManagement_list_02: false,
                invoiceManagement_list_03: false,
                invoiceManagement_invoiceStaging_01: false,
                invoiceManagement_invoiceStaging_02: false,
                invoiceManagement_detail_01: false,
                invoiceManagement_normalInvoice_01: false,
                invoiceManagement_normalInvoice_02: false,
                invoiceManagement_normalInvoice_03: false,
                invoiceManagement_normalInvoice_04: false,
                // invoiceManagement_specialInvoice_01:false,
                invoiceManagement_specialInvoice_02: false,
                invoiceManagement_specialInvoice_03: false,
                invoiceManagement_specialInvoice_04: false,
                customer_list_01: false,
                customer_list_02: false,
                customer_list_03: false,
                productCustomer_list_01: false,
                productCustomer_list_02: false,
                productCustomer_list_03: false,
                customer_detail_01: false,
                customer_detail_02: false,
                customer_detail_03: false,
                customer_detail_04: false,
                stockControl_list_01: false,
                stockControl_list_02: false,
                stockControl_list_03: false,
                stockControl_list_04: false,
                stockControl_list_05: false,
                stockControl_list_06: false,
                subStock_list_01: false,
                subStock_list_02: false,
                subStock_list_03: false,
                subStock_sublibraryTransfer_01: false,
                subStock_sublibraryTransfer_02: false,
                subStock_sublibraryTransfer_03: false,
                reportForm_discountedReport_01: false,
                reportForm_discountStatements_01: false,
                reportForm_accountStatement_01: false,
                reportForm_customerReceivableInquiry_01: false,
                reportForm_customerReturnQuery_01: false,
                invoiceApplyStart_list_01: false,
                invoiceApplyStart_list_02: false,
                invoiceApplyStart_list_03: false,
                invoiceApplyStart_list_04: false,
                product_list_01: false,
                product_list_02: false,
                product_list_03: false,
                product_list_04: false,
                product_list_05: false,
                product_detail_01: false,
                product_detail_02: false,
                product_detail_03: false,
                product_add_03: false,
                invoiceApply_list_01: false,
                invoiceApply_list_02: false,
                invoiceApply_list_03: false,
                product_add_01: false,
                thingsOrder_list_01: false,
                thingsOrder_list_02: false,
                thingsOrder_list_03: false,
                thingsOrder_list_04: false,
                thingsOrder_list_05: false,
                thingsOrder_list_06: false,
                thingsOrder_list_07: false,
                thingsOrder_add_02: false,
                thingsOrder_add_03: false,
                thingsOrder_add_04: false,
                thingsOrder_add_05: false,
                thingsOrder_add_06: false,
                thingsOrder_add_07: false,
                invoiceManagement_specialInvoice_01: false,
                invoiceManagement_specialInvoice_02: false,
                invoiceManagement_specialInvoice_03: false,

                survey_list_01: false,
                survey_list_02: false,
                survey_list_03: false,
                survey_list_04: false,
                info_detail_01: false,
                info_detail_02: false,
                info_list_03: false,
                survey_detail_01: false,
                owning: false,
                customerManagement_detail_01: false,
                customerManagement_detail_02: false,
                customerManagement_detail_03: false,
                customerManagement_detail_04: false,
                customerManagement_detail_05: false,
                customerManagement_detail_06: false,
                customerManagement_detail_07: false,
                lower: false,
                invoiceManagement_01: false,
                delivery: false,
                returnGoodsQuantity: false,
                returnGoodsBusiness: false,
                returnGoodsCommit: false,
                returnGoodsExport: false,
                returnGoodsReport: false,
                custItemList: false,
                rebateBillManage: false,
                rebateBillDetail: false,
                financing: false,
                report: false
            }
            checkRole().then(res => {
                let button_limits = {};
                let resData = res.data;
                for (var i = 0; i < resData.length; i++) {
                    button_limits[resData[i].code] = true;
                    for (var j = 0; j < resData[i].children.length; j++) {
                        button_limits[resData[i].children[j].code] = true;
                        for (var k = 0; k < resData[i].children[j].children.length; k++) {
                            button_limits[resData[i].children[j].children[k].code] = true;
                        }
                    }
                }
                Object.assign(button_limits_end, button_limits);
                window.localStorage.setItem('button_limits_end', JSON.stringify(button_limits_end));
                window.sessionStorage.setItem('session_login_status', 1);
                window.localStorage.setItem('login_user_information', JSON.stringify(result.user || {}));

                if (result.user.roleCode == "cpxx") {
                    window.location.href = '#mallHome';
                } else if (result.user.roleCode == "overseas") {
                    window.location.href = '#productEn';
                } else if (result.user.roleCode == "overseasCust") {
                    window.location.href = '#productEn';
                } else {
                    window.location.href = '#' + config.h5Root;
                }
                if (values && values.remember) {
                    /* 记住密码 */
                    CookieUtils.set('login_data_information', JSON.stringify({
                        'userName': values.userName,
                        'password': values.password
                    }));
                    // window.localStorage.setItem('login_user_information', JSON.stringify(result.user || {}));
                }
            });
            let str = result.user.thirdId == null ? result.user.fatherThirdId : result.user.thirdId
            window.localStorage.setItem('thirdId', str);
        } else {
            openNotice('error', this.state.languageSet.loginFail, (result && result.message) ? result.message : '');
        }
    };
    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({loginDown: true});
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let loginFun = null;
                if (this.state.showAccount) {
                    loginFun = login({
                        loginName: values.userName.trim(),
                        password: values.password.toUpperCase(),
                        language: this.state.language
                    })
                } else {
                    loginFun = loginCode({
                        mobile: values.phoneNumber,
                        code: values.code,
                        language: this.state.language
                    })
                }
                loginFun.then(result => {
                    this.setState({loginDown: false});
                    this.successCallback(result, values);
                });
            }
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {loginData, showAccount, showCode, QrCodeImg, language} = this.state;
        return <div className="login_body">
            <img src={logoA} style={{width: '15%', marginLeft: '12%', marginTop: '2%'}}/>
            <div>
                <p><Radio.Group value={language} onChange={this.chLanguage} style={{
                    position: 'absolute',
                    right: '16%',
                    top: '2%'
                }}>
                    <Radio.Button value="zh">中文</Radio.Button>
                    <Radio.Button value="en">English</Radio.Button>
                </Radio.Group></p>
                <p><span style={{
                    fontSize: '22px',
                    color: '#84b847',
                    position: 'absolute',
                    right: '16%',
                    top: '5%'
                }}>4008-660-006</span></p>
                <p><a href='http://www.tengen.com' style={{
                    fontSize: '17px',
                    color: '#ccc',
                    position: 'absolute',
                    right: '16%',
                    top: '9%'
                }}>www.tengen.com</a></p>
                <p><span style={{
                    fontSize: '17px',
                    color: '#ccc',
                    position: 'absolute',
                    right: '16%',
                    top: '12%'
                }}>{this.state.languageSet.mail}fwb@tengen.com.cn</span></p>
            </div>
            <div className="user_pwd">
                <div style={{
                    fontSize: '19px',
                    color: '#7f807f',
                    fontWeight: 600,
                    marginLeft: '15px',
                    marginBottom: '8px'
                }}>{this.state.languageSet.title}
                </div>
                {!showCode ? (showAccount ? <Form onSubmit={this.handleSubmit} className="login-form">
                        <FormItem>
                            {getFieldDecorator('userName', {
                                rules: [{
                                    required: true,
                                    message: this.state.languageSet.userName
                                }],
                                initialValue: loginData.userName
                            })(
                                <Input prefix={<Icon type="user" style={{fontSize: 13}}/>}
                                       placeholder={this.state.languageSet.userNameTip}/>
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [{
                                    required: true,
                                    message: this.state.languageSet.password
                                }],
                                initialValue: loginData.password
                            })(
                                <Input prefix={<Icon type="lock" style={{fontSize: 13}}/>} type="password"
                                       placeholder={this.state.languageSet.passwordTip}/>
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('remember', {
                                valuePropName: 'checked',
                                initialValue: false,
                            })(
                                <Checkbox>{this.state.languageSet.remember}</Checkbox>
                            )}
                            <br/>
                            <Button type="primary" htmlType="submit" className="login-form-button"
                                    disabled={this.state.loginDown}>{this.state.languageSet.loginbtn}</Button>
                            {/*<Button type="button" size="small" className="toggle-form-button"*/}
                            {/*        onClick={this.toggleLoginType}>短信验证码登录</Button>*/}
                            {/*<Button type="button" size="small" className="toggle-form-button"*/}
                            {/*        onClick={this.showCodeLogin}>扫描二维码登录</Button>*/}
                        </FormItem>
                    </Form> :
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <FormItem>
                            {getFieldDecorator('phoneNumber', {
                                rules: [{
                                    required: true, message: '请输入手机号码!'
                                }, {
                                    validator: checkPhone
                                }]
                            })(
                                <Input prefix={<Icon type="mobile" style={{fontSize: 13}}/>} placeholder="手机号码"/>
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('code', {
                                rules: [{required: true, message: '请输入验证码!'}]
                            })(
                                <Input prefix={<Icon type="lock" style={{fontSize: 13}}/>} placeholder="验证码"/>
                            )}
                        </FormItem>
                        <FormItem>
                            <Button type="button" size="small" className="code-form-button"
                                    disabled={this.state.showCountdown}
                                    onClick={this.getCode}>{this.state.showCountdown ? this.state.countdown + '秒后重试' : '发送验证码'}</Button><br/>
                            <Button type="primary" htmlType="submit" className="login-form-button"
                                    disabled={this.state.loginDown}>{this.state.languageSet.loginbtn}</Button>
                            <Button type="button" size="small" className="toggle-form-button"
                                    onClick={this.toggleLoginType}>账号密码登录</Button>
                            <Button type="button" size="small" className="toggle-form-button"
                                    onClick={this.showCodeLogin}>扫描二维码登录</Button>
                        </FormItem>
                    </Form>) : <div>
                    <img
                        src={QrCodeImg}
                        onLoad={() => {
                            this.checkQrCodeLogin()
                        }}
                        style={{width: '70%', marginLeft: '13%'}}/>
                    <Button type="button" size="small" className="toggle-form-button"
                            onClick={() => {
                                this.setState({showCode: false, showAccount: true}), clearInterval(this.timer)
                            }}>账号密码登录</Button>
                    <Button type="button" size="small" className="toggle-form-button"
                            onClick={() => {
                                this.setState({showCode: false, showAccount: false}), clearInterval(this.timer)
                            }}>短信验证码登录</Button>
                </div>}
                {/*<p className="loginForget">忘记登录信息？获取登录帮助</p>*/}
                <div className="qrCode">
                    <img width="45%"
                         height="auto"
                         alt="下载App"
                         src={config.index == 1 ? xiaZaiApp : xiaZaiAppCs}
                         style={{float: 'left'}}
                    />
                    <span
                        style={{
                            float: 'left',
                            marginTop: '30px',
                            marginLeft: '10px',
                            color: '#3f3d3d'
                        }}>{this.state.languageSet.tip2}</span>
                    {/*<span style={{*/}
                    {/*    float: 'left',*/}
                    {/*    marginLeft: '10px',*/}
                    {/*    color: '#cecece'*/}
                    {/*}}>{this.state.languageSet.tip3}</span>*/}

                    {/*<img width="45%" height="auto" alt="产品logo"
               src={require('../../assets/images/QrCode.png')} />
          <img className="qrCode-right" width="45%" height="auto" alt="产品logo"
               src={require('../../assets/images/QrCode.png')} />*/}
                </div>
                {/*<p className="address">www.tengen.com</p>*/}
            </div>
            <div style={{
                fontSize: '12px',
                color: '#ccc',
                position: 'absolute',
                left: '37%',
                bottom: '3%'
            }}>Copyright &copy;2017 {this.state.languageSet.company} All Rights Reserved
            </div>
        </div>
    }
}

const WrappedNormalLoginForm = Form.create()(Login);
export default WrappedNormalLoginForm;



// WEBPACK FOOTER //
// ./src/routes/home/login.js